import React from 'react';
import styles from './contactPointSearcher.module.scss';
import { IContactPointViewItem } from '../../../interfaces';
import TileView from './TileView';

interface IContactPointViewLineProps {
    contactGroupPoints?: IContactPointViewItem[];
    onViewLineClick?: (view: IContactPointViewItem, event: React.SyntheticEvent, back?: boolean) => void;
    selectedContactStack?: IContactPointViewItem[];
}

const ContactPointViewLine = ({
    contactGroupPoints,
    selectedContactStack,
    onViewLineClick,
}: IContactPointViewLineProps): JSX.Element => {
    return (
        <>
            <h2 className={styles.parentNameWrap}>
                {selectedContactStack?.map((parent, index) => (
                    <div className={styles.parentName} key={index + '_' + parent}>
                        {parent?.name}
                    </div>
                ))}
            </h2>
            <div className={styles.categoryOuter}>
                {contactGroupPoints?.map((contact: IContactPointViewItem, index: number) => (
                    <TileView key={index} contact={contact} onViewLineClick={onViewLineClick} />
                ))}
            </div>
        </>
    );
};

export default ContactPointViewLine;
